import { FcApproval } from "react-icons/fc";
import { useHistory } from "react-router-dom";
import ReactGA from "react-ga";
import CustomButton from "../../components/CustomButton";

import CONSTANTS from "../../utils/constants/CONSTANTS";
import { eventTrack, eventTrackGA4 } from "../../utils/helperFunctions";

import "./index.scss";

const SuccessPage = () => {
  ReactGA.pageview(window.location.pathname + window.location.search);

  const history = useHistory();
  const navigateBack = () => {
    eventTrack("Contact Form Submission", "Contact form submitted", "Form Submission");
    eventTrackGA4("Contact Form Submission", "Contact form submitted", "Form Submission");
    history.goBack();
    window.scrollTo(0, 0);
  };
  return (
    <div className="success-page">
      <div className="form-submission">
        <div className="tick-icon">
          <FcApproval style={{ fontSize: "20rem" }} className="tick" />
        </div>
        <div className="content">
          <div className="title">Success</div>
          <div className="message">Your form has been successfully submitted</div>
          <div className="message">we'll be in touch shortly!</div>
          <div className="btn">
            <CustomButton className="button" type={CONSTANTS.SAVE_TYPE} handleClick={navigateBack}>
              Done
            </CustomButton>
          </div>
        </div>
      </div>
    </div>
  );
};
export default SuccessPage;
